import * as React from "react"
import {
  SettingsCard,
  SettingsCardTitle,
  SettingsCardContent,
} from "@modules/site/settings"
import { logDrainIntegration as text } from "@modules/locales/default.js"
import { ThemeCss } from "gatsby-interface"
import { useFlags } from "@modules/featureFlags"
import { LogDrainIntegrationsList } from "@modules/logDrain/shared/components/LogDrainIntegrationList"
import { useState } from "react"
import { LogDrainConnectBlockUp } from "./LogDrainsSection.parts"
import { LogDrainIntegrationModal } from "@modules/logDrain/shared/components/LogDrainIntegrationModal"
import { LogDrainIntegration, LogDrainProvider } from "@modules/graphql/types"
import { useGetLogDrainIntegrationByProviderAndSiteQuery } from "@modules/logDrain/shared/queries.generated"
import { LogDrainDeleteModal } from "@modules/logDrain/datadog/components/LogDrainDeleteModal"

export type LogDrainsSectionProps = {
  siteId: string
  organizationId: string
  siteName: string
}

export function LogDrainsSection({
  siteId,
  siteName,
  organizationId,
}: LogDrainsSectionProps) {
  const { data, refetch } = useGetLogDrainIntegrationByProviderAndSiteQuery({
    variables: {
      siteId,
      logDrainProvider: LogDrainProvider.Datadog,
    },
  })

  const [selectedLogDrainToEdit, setSelectedLogDrainToEdit] = useState<
    LogDrainIntegration
  >()
  const [selectedLogDrainToRemove, setSelectedLogDrainToRemove] = useState<
    LogDrainIntegration
  >()
  const [isBlockUpOpen, setIsBlockupOpen] = useState<boolean>(false)

  const handleSelect = (val: LogDrainIntegration) => {
    setSelectedLogDrainToEdit(val)
  }

  const handleConnect = () => {
    refetch()
  }

  return (
    <React.Fragment>
      <SettingsCard>
        <SettingsCardTitle>{text.headers.logDrains}</SettingsCardTitle>
        <SettingsCardContent>
          <div css={descriptionCss}>
            Easily sync your site's hosting logs to third-party logging
            providers.
          </div>
          <LogDrainIntegrationsList
            onDelete={setSelectedLogDrainToRemove}
            onSelect={handleSelect}
            allowToEdit={true}
            integrations={
              data?.getLogDrainIntegrationByProviderAndSite
                ? ([
                    data?.getLogDrainIntegrationByProviderAndSite,
                  ] as LogDrainIntegration[])
                : undefined
            }
          />
        </SettingsCardContent>
      </SettingsCard>

      {selectedLogDrainToEdit && (
        <LogDrainIntegrationModal
          siteId={siteId}
          logDrain={selectedLogDrainToEdit}
          onClose={() => setSelectedLogDrainToEdit(undefined)}
          onSuccess={handleConnect}
        />
      )}

      {selectedLogDrainToRemove && (
        <LogDrainDeleteModal
          logDrain={selectedLogDrainToRemove}
          siteId={siteId}
          siteName={siteName}
          onClose={() => setSelectedLogDrainToRemove(undefined)}
          onSuccess={handleConnect}
        />
      )}

      <LogDrainConnectBlockUp
        organizationId={organizationId}
        isOpen={isBlockUpOpen}
        onDissmis={() => setIsBlockupOpen(false)}
      />
    </React.Fragment>
  )
}

/* Styles */
const descriptionCss: ThemeCss = theme => ({
  fontSize: theme.fontSizes[1],
  color: `#716F76`,
  marginBottom: theme.space[4],
})
